import React from 'react';
import "./index.css";

interface PolicyPreviewProps {
    policyName: string;
    group: string;
    systemResource: string[];
    scope: string | undefined;
}

const PolicyPreview: React.FC<PolicyPreviewProps> = ({policyName, group, systemResource, scope}) => {

    return (
        <div className={"policyPreviewContainer"}>
            <div className="input-fields">
                <div>
                    <div className="label">Policy name</div>
                    <div className="content">{policyName}</div>
                </div>
                <div>
                    <div className="label">Business team</div>
                    <div className="content">{group}</div>
                </div>
                <div>
                    <div className="label">System</div>
                    <div className="content">Sisense</div>
                </div>
                <div>
                    <div className="label">System Resources</div>
                    <div className="content">{systemResource.join(',')}</div>
                </div>
                <div>
                    <div className="label">Scope</div>
                    <div className="content">{scope}</div>
                </div>
                <div>
                    <div className="label">Access type</div>
                    <div className="content">View</div>
                </div>
            </div>
        </div>
    );
};

export default PolicyPreview;